import { combineReducers } from 'redux'
import { combineEpics } from 'redux-observable'

import knowledgeBaseReducer, { epic as knowledgeBaseEpic } from './knowledgebase'
import settingsReducer, { epic as settingsEpic } from './settings'
import searchReducer, { epic as searchEpic } from './search'
import { epic as userEpic } from './user'

export const rootReducer = combineReducers({
  knowledgebase: knowledgeBaseReducer,
  settings: settingsReducer,
  search: searchReducer
})

export const rootEpic = combineEpics(knowledgeBaseEpic, settingsEpic, searchEpic, userEpic)
